import { render, staticRenderFns } from "./age-ruler.vue?vue&type=template&id=21cce3f5&scoped=true&"
import script from "./age-ruler.vue?vue&type=script&lang=js&"
export * from "./age-ruler.vue?vue&type=script&lang=js&"
import style0 from "./age-ruler.vue?vue&type=style&index=0&id=21cce3f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cce3f5",
  null
  
)

export default component.exports